// extracted by mini-css-extract-plugin
export default {"root":"videoPopup_root__Jxalw","container":"videoPopup_container__Eti7g","closeButton":"videoPopup_closeButton__IssHo","iconContainer":"videoPopup_iconContainer__yMrjB"};